import { useEffect, useRef } from "react";
import { followMe, followMePratBubbla as followMeBubbla, live, liveBgSky } from "../assets";
import { BANDSINTOWN_URL } from "../bandsintown";
import { HomeButton, MuteToggle, SiteNav } from "../components/SiteChrome";
import { SocialIcons } from "../components/SocialIcons";
import { TourDates } from "../components/TourDates";
import { isWarm } from "../routePrewarm";
import "./Live.css";

export function Live() {
  const bgRef = useRef<HTMLImageElement>(null);
  // Warmed by routePrewarm while the landing page sat idle: if the bitmap is
  // already decoded, the sky is opaque in the first painted frame instead of
  // fading up over half a second. See src/routePrewarm.ts.
  const warm = useRef(isWarm(liveBgSky)).current;

  useEffect(() => {
    if (bgRef.current?.complete) bgRef.current.classList.add("loaded");
  }, []);

  return (
    <div className="page-live">
      <img
        id="live-bg-video"
        className={warm ? "loaded no-fade" : undefined}
        ref={bgRef}
        src={liveBgSky}
        alt=""
        onLoad={(e) => e.currentTarget.classList.add("loaded")}
      />

      <SocialIcons />

      <HomeButton />
      <MuteToggle />
      <SiteNav active="/live" />

      <div id="page-wrap">
        <img id="live-title" src={live} alt="Live" />

        <div id="tour-dates-wrap">
          <TourDates />
        </div>

        <div id="follow-section">
          <p>Get notified when I&apos;m in town</p>
          <div id="follow-button-wrap">
            <img id="follow-bubble" src={followMeBubbla} alt="" />
            <a
              id="follow-button"
              className="interactive"
              href={BANDSINTOWN_URL}
              target="_blank"
              rel="noopener"
            >
              <img src={followMe} alt="" />
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}
